import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Switch from '@material-ui/core/Switch';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CommonButton from '../../CommonComponents/CommonButton';
import { updateDashUser } from '../../redux/actions/dashusers';
import ManagerSubTable from './ManagerSubTable';

const DashUserRow = ({
  row, selectUser, setUpdateUser, setLocalState, updateManager,
}) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={row.id}
      >
        <TableCell align="left">
          {row.full_name}
        </TableCell>
        <TableCell align="left">
          {row.username}
        </TableCell>
        <TableCell align="left">
          {row.email}
        </TableCell>
        <TableCell align="left">
          <div>
            { row.managerProducts && row.managerProducts.length > 0
              ? (
                <CommonButton
                  color="primary"
                  basic="true"
                  onClick={() => setOpen(!open)}
                >
                  <b>View</b>
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </CommonButton>
              )
              : null}
          </div>
        </TableCell>
        <TableCell align="left">
          {row.mobile}
        </TableCell>
        <TableCell align="left">
          <CommonButton
            color="primary"
            basic="true"
            onClick={() => selectUser(row)}
          >
            <b>Assign</b>
          </CommonButton>
        </TableCell>
        <TableCell align="left">
          {row.userType}
        </TableCell>
        <TableCell align="left" padding="none">
          <CommonButton
            color="primary"
            basic="true"
            onClick={() => setUpdateUser(row)}
          >
            <b>Edit</b>
          </CommonButton>
        </TableCell>
        <TableCell align="left" padding="none">
          <Switch
            checked={row.status}
            onChange={() => updateManager({ status: !row.status }, row.id, 'manager')}
            color="primary"
            name="checkedA"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        </TableCell>
        <TableCell align="left">
          {moment(row.updatedAt).format('DD MMM YYYY, h:mm:ss a')}
        </TableCell>
      </TableRow>
      <ManagerSubTable
        id={row.id}
        open={open}
        managerProducts={row.managerProducts}
        setLocalState={setLocalState}
      />
    </>
  )
}

const mapActions = {
  updateManager: updateDashUser,
};

export default connect(null, mapActions)(DashUserRow);
